import { useContext, useEffect, useState } from "react";
import jwtDecode from "jwt-decode";
import Logo from "../../assets/img/skor-white-logo.svg";
import Flag from "../../assets/img/flag.svg";
import AuthContext from "../../context/auth/AuthContext";
import i18next from "i18next";
import useTranslator from "../../hooks/useTranslator";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { calculatePaymentScore, clearPaymentData } from "../../helper/common";
import ProcessPassedModal from "../onboarding/ProcessPassedModal";

const TenantBankVerificationRequest = () => {
  const { _t } = useTranslator();
  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("i18nextLng").toLowerCase() || "en-us"
  );
  const authContext = useContext(AuthContext);
  const { changeUserLng } = authContext;

  const [userToken, setUserToken] = useState({
    landlord_name: "",
    tenant_id: "",
    requested_tenant_name: "",
  });
  const [countryCodeError, setCountryCodeError] = useState("");
  const [tink_countryCode, setTink_countryCode] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleLanguageChange = async (langVal) => {
    await i18next.changeLanguage(langVal);
    await changeUserLng();
    setCurrentLang(langVal);
  };
  const navigate = useNavigate();
  const queryParameters = new URLSearchParams(window.location.search);
  const userTokenParam = queryParameters.get("userToken");
  let account_verification_report_id = queryParameters.get(
    "account_verification_report_id"
  );
  let transaction_report_id = queryParameters.get("transaction_report_id");

  useEffect(() => {
    const decoded = jwtDecode(userTokenParam);
    setUserToken(decoded);

    if (
      userTokenParam &&
      account_verification_report_id &&
      transaction_report_id
    ) {
      calculateScore(
        userTokenParam,
        account_verification_report_id,
        transaction_report_id
      );
      return;
    }
  }, []);

  const calculateScore = async (
    userTokenParam,
    accountverificationid,
    transactionreportid
  ) => {
    account_verification_report_id = null;
    transaction_report_id = null;
    await clearPaymentData(userTokenParam);
    setShowConfirmation(true);
    calculatePaymentScore(
      userTokenParam,
      accountverificationid,
      transactionreportid
    );
  };

  const changeCountryCode = (e) => {
    setTink_countryCode(e.target.value);
  };

  const connectToBank = (e) => {
    e.preventDefault();
    if (!tink_countryCode) {
      setCountryCodeError(_t("pleaseSelectCountryCode"));
      return;
    } else {
      setCountryCodeError("");
    }
    var lang = "en_US";
    if (localStorage.getItem("i18nextLng") == "es") {
      lang = "es_ES";
    }

    let baseUrl = `https://link.tink.com/1.0/reports/create-report?client_id=${process.env.REACT_APP_TINK_CLIENT_ID}&market=${tink_countryCode}&locale=${lang}&report_types=TRANSACTION_REPORT,ACCOUNT_VERIFICATION_REPORT&refreshable_items=IDENTITY_DATA,CHECKING_ACCOUNTS,SAVING_ACCOUNTS,CHECKING_TRANSACTIONS,SAVING_TRANSACTIONS&account_dialog_type=SINGLE`;

    let tinkUrlLiveFront;

    tinkUrlLiveFront = `${baseUrl}&redirect_uri=https%3A%2F%2F${process.env.REACT_APP_URL_NAME}%2Ftenant-bank-verification?userToken=${userTokenParam}`;
    window.open(tinkUrlLiveFront, "_self");
  };

  return (
    <>
      <div className="tenant-bank-verification-comp">
        <div className="tenant-bank-verification-comp-header">
          <div className="tenant-bank-verification-comp-header-logo">
            <img src={Logo} alt="logo" />
          </div>

          <div className="tenant-bank-verification-comp-lang">
            {currentLang == "es" ? (
              <div
                className="language-switch-container language-switch-container-es  cursor-pointer"
                onClick={() => handleLanguageChange("en-us")}
              >
                <p>ES</p>
                <img
                  className="flag-image"
                  alt="Flag"
                  src="/images/spain-flag.png"
                />
              </div>
            ) : (
              <div
                className="language-switch-container cursor-pointer"
                onClick={(e) => handleLanguageChange("es")}
              >
                <img className="flag-image" alt="Flag" src={Flag} />
                <p>EN</p>
              </div>
            )}
          </div>
        </div>
        <div className="tenant-bank-verification-comp-modal">
          <div className="tenant-bank-verification-comp-modal-left">
            <div className="tenant-bank-verification-comp-modal-left-gap">
              <div className="d-flex justify-content-between verify-bank-gap">
                <div className="tenant-bank-verification-comp-modal-left-info">
                  <img src="/images/verify-1.svg" alt="" />
                  <p>{_t("securityAndPrivacyAreGuaranteed")}</p>
                </div>
                <div className="tenant-bank-verification-comp-modal-left-info">
                  <img src="/images/verify-2.svg" alt="" />
                  <p>{_t("automaticAnalysisWithInstantResults")}</p>
                </div>
              </div>
              <div className="d-flex justify-content-between verify-bank-gap">
                <div className="tenant-bank-verification-comp-modal-left-info">
                  <img src="/images/verify-3.svg" alt="" />
                  <p>{_t("makingRentingProcessEasy")}</p>
                </div>
                <div className="tenant-bank-verification-comp-modal-left-info">
                  <img src="/images/verify-4.svg" alt="" />
                  <p>{_t("landlordCannotAccessYourBank")}</p>
                </div>
              </div>
            </div>
            <img
              className="tenant-bank-verification-comp-modal-img"
              src="/images/tenant-bank-verification.png"
              alt="bank_logo"
            />
            <p className="text-white">
              {_t(
                "weAssureYouOfTheUtmostPrivacyAndSecurityOfYourFinancialData"
              )}
            </p>
          </div>
          <div className="tenant-bank-verification-comp-modal-right">
            <div>
              <h1>{_t("bankVerificationRequest")}</h1>
              <p>
                {userToken?.landlord_name
                  ? _t("aLandlordHasRequestedYouToCompleteYourBankVerification")
                  : _t("aTenantHasRequestedYouToCompleteYourBankVerification")}
              </p>
              <div className="request-comp">
                <span>{_t("requestedBy")}: </span>
                <div>
                  <img src="/images/user-verify.svg" alt="" />
                  <p>
                    <span>
                      {userToken?.landlord_name ??
                        userToken?.requested_tenant_name}
                    </span>
                    {userToken?.landlord_name ? _t("landlord") : _t("tenant")}
                  </p>
                </div>
              </div>
            </div>
            <Form className="loginform" onSubmit={connectToBank}>
              <div style={{ textAlign: "left" }} className="auth-form">
                <div className="bigform h-auto w-100">
                  <div className="form-grid w-100">
                    <div className="form-group w-100">
                      <label className="">{_t("country")}</label>
                      <select
                        id="employment_status"
                        onChange={changeCountryCode}
                      >
                        <option value="">{_t("selectYourCountry")}</option>
                        <option value="BE">{_t("belgium")}</option>
                        <option value="DE">{_t("germany")}</option>
                        <option value="DK">{_t("denmark")}</option>
                        <option value="EE">{_t("estonia")}</option>
                        <option value="ES">{_t("spain")}</option>
                        <option value="FI">{_t("finland")}</option>
                        <option value="FR">{_t("france")}</option>
                        <option value="GB">{_t("unitedKingdom")}</option>
                        <option value="IT">{_t("italy")}</option>
                        <option value="LT">{_t("lithuania")}</option>
                        <option value="LV">{_t("latvia")}</option>
                        <option value="NL">{_t("netherlands")}</option>
                        <option value="NO">{_t("norway")}</option>
                        <option value="PL">{_t("poland")}</option>
                        <option value="PT">{_t("portugal")}</option>
                        <option value="SE">{_t("sweden")}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <button className="connect-bank-btn">
                  <img src="/images/connect-bank-icon.svg" alt="" />
                  {_t("connectBank")}
                </button>
              </div>
            </Form>
            <div className="verify-bank-footer">
              {_t("shouldYouHaveAnyConcernsOrQuestionsPlease")}
              <a
                href={undefined}
                onClick={(e) => navigate("/bank")}
                className="verify-btn-link"
              >
                {_t("readHere")}
              </a>
              {_t("orContactUsAt")}
              <a href="mailTo:info@skortorent.com" className="verify-btn-link">
                info@skortorent.com.
              </a>
            </div>
          </div>
        </div>
      </div>
      {showConfirmation && (
        <ProcessPassedModal
          showPopup={showConfirmation}
          heading={_t("bankVerificationCompleted", "new tt bank connection")}
          subheading={_t(
            "yourBankHasBeenSuccessfullyConnected",
            "new tt bank connection"
          )}
          buttonText={_t("Done")}
          handleClick={(e) => {
            navigate("/home");
          }}
        />
      )}
    </>
  );
};

export default TenantBankVerificationRequest;
